import { isAxiosError } from 'axios';

const APPROVAL_LETTER_GENERIC_ERROR =
  'An error occurred while trying to upload the approval letter, please try again.';

export function getPostApprovalLetterError(error: unknown): string | null {
  if (!error) return null;
  if (
    isAxiosError(error) &&
    error.response?.status === 400 &&
    typeof error.response.data === 'object' &&
    error.response.data &&
    typeof error.response.data.detail === 'string'
  ) {
    return error.response.data.detail;
  }
  return APPROVAL_LETTER_GENERIC_ERROR;
}
